/* tslint:disable */

/**
 */
export class GPSRecord {
    timestamp?: number;
    lat?: number;
    lng?: number;
}
